import React, { useState } from "react";
import styled from "@emotion/styled";

import {
  Button,
  Card as MuiCard,
  CardActions,
  CardContent as MuiCardContent,
  Typography as MuiTypography,
} from "@mui/material";
import { spacing, SpacingProps } from "@mui/system";

import { deleteBookmarkFromDB } from "../../../firebase/utils";
import { Bookmark } from "../../../types/app";
import BookmarkCardTitle from "./BookmarkCardTitle";
import { SnackbarFns, ViewFile } from "../../../utils/fnsRedux";
import { setBookmarkDeleteTracker } from "../../../redux/slices/bookmark";
import useAppDispatch from "../../../hooks/useAppDispatch";

const Card = styled(MuiCard)`
  height: 100%;
  border-radius: 15px;
  box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.2);
`;

const CardContent = styled(MuiCardContent)`
  border-bottom: 1px solid ${(props) => props.theme.palette.grey[300]};
  height: calc(100% - ${45}px);
  padding: 20px;
`;

interface TypographyProps extends SpacingProps {
  component?: string;
}
const Typography = styled(MuiTypography)<TypographyProps>(spacing);

function BookmarkCard({ bookmark }: { bookmark: Bookmark }) {
  const handleSnackbar = SnackbarFns();
  const onClick = ViewFile();
  const dispatch = useAppDispatch();
  const [disabled, setDisabled] = useState(false);

  async function handleDelete() {
    setDisabled(true);
    await deleteBookmarkFromDB(bookmark);
    handleSnackbar("success", "Bookmark Successfully Deleted!", true);
    dispatch(setBookmarkDeleteTracker());
    setDisabled(false);
  }

  return (
    <Card>
      <CardContent>
        <BookmarkCardTitle bookmark={bookmark} />
        <Typography mb={4} color="textSecondary" component="p">
          {bookmark.displayText}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          color="primary"
          onClick={() =>
            onClick(bookmark.searchText, bookmark.pdfName, bookmark.page)
          }
        >
          View
        </Button>
        <Button
          disabled={disabled}
          size="small"
          color="error"
          onClick={() => handleDelete()}
        >
          Delete
        </Button>
        <Typography
          marginLeft={3}
          maxWidth={`calc(100% - ${215}px)`}
          noWrap
          component="div"
          textOverflow="ellipsis"
        >
          {bookmark.pdfName}
        </Typography>
        <Typography color="textSecondary" component="div">
          page {bookmark.page + 1}
        </Typography>
      </CardActions>
    </Card>
  );
}

export default BookmarkCard;
